import {FC, ReactElement} from 'react';
import {Checkbox, CheckboxProps, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel} from "@mui/material";
import {FieldArray} from "react-final-form-arrays";
import {Field, FieldProps, FieldRenderProps} from "react-final-form";
import {StackedLabel} from "./shared/StackedLabel";

interface CheckBoxFieldProps extends FieldRenderProps<boolean> {
  inputProps?: CheckboxProps;
  label: ReactElement;
  subLabel: ReactElement;
  withoutHelperText?: boolean;
}

const CheckBoxField: FC<CheckBoxFieldProps> = ({input, meta: {invalid, error}, inputProps, label, subLabel, withoutHelperText, ...custom}) => (
  <FormControl error={invalid}>
    <FormControlLabel
      label={<StackedLabel label={label} subLabel={subLabel}/>}
      control={
        <Checkbox
          checked={input.checked || input.value}
          onChange={input.onChange}
          color={"primary"}
          {...inputProps}
        />
      }
      {...custom}
    />
    {
      invalid && !withoutHelperText && (
        <FormHelperText>
          {error}
        </FormHelperText>
      )
    }
  </FormControl>
);

interface CheckBoxGroupFieldPrps {
  column?: boolean;
  label: ReactElement;
  labels: ReactElement[];
  name: string;
  required?: boolean;
  validate?: FieldProps["validate"];
}

const CheckBoxGroupField: FC<CheckBoxGroupFieldPrps> = ({name, label, labels, required, validate, column}) => (
  <FieldArray name={name} validate={validate}>
    {
      ({fields, meta: {invalid, error}}) => (
        <FormControl
          required={required} component={"fieldset"}
          variant="filled"
          fullWidth
        >
          <FormLabel component={"legend"}>{label}</FormLabel>
          <FormGroup row={!column}>
            {
              fields.map((checkbox, index) => (
                <Field
                  name={`${checkbox}.checked`} key={`checkbox_${index}`}
                  component={CheckBoxField} type={"checkbox"}
                  label={labels[index]}
                />
              ))
            }
          </FormGroup>
          {
            invalid && (
              <FormHelperText error>
                {error}
              </FormHelperText>
            )
          }
        </FormControl>
      )
    }
  </FieldArray>
);

export {CheckBoxField, CheckBoxGroupField};
